import { render, staticRenderFns } from "./KycFaq.vue?vue&type=template&id=9a723556"
import script from "./KycFaq.vue?vue&type=script&lang=ts"
export * from "./KycFaq.vue?vue&type=script&lang=ts"
import style0 from "./KycFaq.vue?vue&type=style&index=0&id=9a723556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports